<template>
    <ion-item-option :color="ION_VARIANT.LIGHT">
        <input-amount-performance
            v-model="model"
            :min="minValue"
            :max="limitOrderSize"
            :amount-step="stepSize"
            :direct-input-disabled="directInputDisabled"
        />
    </ion-item-option>
</template>

<script setup lang="ts">
import { IonItemOption } from "@ionic/vue";
import { computed } from "vue";

import InputAmountPerformance from "@/components/input/InputAmountPerformance.vue";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { SliderOptionAmountProps } from "@/types/props";
import { SliderOptionAmountEmits } from "@/types/emits";

const props = defineProps<SliderOptionAmountProps>()
const emit = defineEmits<SliderOptionAmountEmits>()

const model = computed<string | number | undefined>({
    get: () => {
        return props.modelValue
    },
    set: (value) => {
        emit('update:modelValue', Number(value))
    }
})
</script>
